export default function CRTOverlay() {
  return (
    <>
      <div
        aria-hidden="true"
        className="crt-scanlines pointer-events-none fixed inset-0 z-[90] opacity-20 mix-blend-overlay"
      />
      <div
        aria-hidden="true"
        className="crt-noise pointer-events-none fixed inset-0 z-[91] opacity-[0.05]"
      />
      <div
        aria-hidden="true"
        className="crt-vignette pointer-events-none fixed inset-0 z-[92]"
      />
    </>
  );
}
